import { createSelector } from 'reselect'
import { Shared } from 'types/Shared'
import { QA } from 'types/Shared/QA'
import { getShared } from './helpers'

export const getQA = createSelector([getShared], ({ qa }: Shared): QA => qa || {})

export const getQAEnabled = createSelector([getQA], ({ enabled }: QA): string => enabled || '')

export const getIsQAEnabled = createSelector([getQAEnabled], (value: string): boolean => !!value)
